
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { DisenioPlanilla } from "../../layout"
import { BackdropScreen, TarjetasOpciones } from "../../components";
import { descargarPlanillaVenta } from "../../../services/utilities/documentos.service";
import { descargarPdf } from "../../../helpers";
import { usePlanillaXID } from "../../../hooks";
import { startEliminarPlanilla } from "../../../services";

import Swal from "sweetalert2";





export const OpcionesPlanilla = () => {


    const { id } = useParams();
    const navegate = useNavigate();
    const { planillaXIDQuery } = usePlanillaXID(`${id}`);
    const lote = planillaXIDQuery?.data;
    const [cargando, setCargando] = useState(false);


    const handleNavegar = (url) => {
        navegate(`/admin/planilla/${id}/${url}`)
    }


    const handleEditarPlanilla = (url) => {
        navegate(`/admin/planilla/${lote.lotegalpon._id}/${id}/${url}`)
    }


    const handleDescargarInfo = async() => {
        const plani = planillaXIDQuery?.data;
        const nombre = `Planilla-#${plani.numero}-${plani.cliente.nombre}`;
        setCargando(true);
        const data = await descargarPlanillaVenta(id);
        setCargando(false);
        descargarPdf(data, nombre);
    }



    const handleEliminarPla = async(e) => {
        await Swal.fire({
            title: `Eliminar Planilla`,
            text: `¿Deseas eliminar esta planilla?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        }).then(async( result ) => {
            if(result.value){
                const resp = await startEliminarPlanilla(id);
                if( resp ){ navegate(-1) }
            }
        });
    }


    const data = [
        {key:1, titulo:'Editar Planilla', function: handleEditarPlanilla, url:'edit', icono:'setting'},
        // {key:2, titulo:'Información Planilla', function: handleNavegar, url:'info', icono:'info'},
        {key:3, titulo:'Cargueros', function:handleNavegar, url:'cargueros', icono:'usuarios'},
        // {key:6, titulo:'Mermas', function: handleNavegar, url:'mermas', icono:'merma'},
        {key:7, titulo:'Descargar Planilla', function: handleDescargarInfo, url:null, icono:'descargar'},
        {key:8, titulo:'Eliminar Planilla', function: handleEliminarPla, url:null, icono:'eliminar'},
    ];





    return (

        <DisenioPlanilla titulo="Opciones de Planilla">
            <BackdropScreen titulo="Descargando Información" cargando={cargando} />

            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>

        </DisenioPlanilla>
    )
}
